// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import ObserveVisibility from 'vue-observe-visibility'
import VueWorker from 'vue-worker'
import LoadScript from 'vue-plugin-load-script'
import Notifications from '@voerro/vue-notifications'
import 'regenerator-runtime/runtime.js'
// eslint-disable-next-line
import {configureFakeBackend, TimeFormatFilter, DateFormatFilter, JalaliDateFormatFilter, router, rbacMixin, NumberTSFormatFilter} from './_helpers'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import config from 'config'
import { store } from './_store'
import VeeValidate from 'vee-validate'
import validationMessagesEn from 'vee-validate/dist/locale/en'
import validationMessagesFa from 'vee-validate/dist/locale/fa'
import emojione from 'emojione'
import VueI18n from 'vue-i18n'
import { languages, defaultLocale } from './locale/index.js'
import VueTippy, { TippyComponent } from 'vue-tippy'
import themes from '@/assets/scss/themes.scss'
import 'es6-promise/auto'

import 'bootstrap/dist/css/bootstrap.css'
import '@/assets/css/bootstrap.rtl.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/css/fontawesome.min.css'
import '@/assets/css/simple-line-icons.css'
import '@/assets/scss/style.scss'
import '@/assets/scss/print.scss'
import '@/assets/css/three-dots.css'
import 'emojionearea/dist/emojionearea.min.css'

global.jQuery = require('jquery')
var $ = global.jQuery
window.$ = $

global.persianDate = require('persian-date')
var persianDate = global.persianDate
window.persianDate = persianDate

Vue.config.productionTip = false
Vue.use(VueWorker)
Vue.use(ObserveVisibility)
Vue.use(LoadScript)
Vue.use(TimeFormatFilter)
Vue.use(NumberTSFormatFilter)
Vue.use(DateFormatFilter)
Vue.use(JalaliDateFormatFilter)
Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueI18n)
Vue.component('smiley-text', {
  props: ['content'],
  render: function (h) {
    return h('span', {
      class: { 'smiley': true },
      domProps: {
        innerHTML: emojione.toImage(this.content)
      }
    })
  }
})
Vue.use(VueTippy)
Vue.component('tippy', TippyComponent)
Vue.component('notifications', Notifications)

const messages = Object.assign(languages)
var i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'en',
  messages
})
Vue.use(VeeValidate, {
  fieldsBagName: 'veeFields',
  i18nRootKey: 'validations', // customize the root path for validation messages.
  i18n,
  dictionary: {
    en: validationMessagesEn,
    fa: validationMessagesFa
  }
})

if (config.fakeBackend) {
  configureFakeBackend()
}

Vue.mixin(rbacMixin)
Vue.mixin({
  data () {
    return {
      themes: themes
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js